import { map } from 'rxjs/operators';

import { getLoggedInUserAsObservable } from './user-tenant-data';

export const hasBetaObs = (beta) => {
  return getLoggedInUserAsObservable()
    .pipe(map(({ betas }) => betas.includes(beta)));
};